import Box from "@mui/material/Box";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import { Course } from "context/SchoolContext";

interface PropTypes {
    title: string;
    description?: string;
    courses: Course[]
}

function CoursesRequiredForLicense(props: PropTypes): JSX.Element {
    return (
        <Box display="flex" flexDirection="column">
            <Box>
                <Box>
                    <Typography marginBottom={2} variant="h3" align={'center'} sx={{ fontWeight: 700 }}>
                        {props.title}
                    </Typography>
                </Box>
                <Typography marginBottom={4} variant="h6" component="p" align={'center'}>
                    {props.description}
                </Typography>
            </Box>

            {props.courses.map((course: Course, index: number) => (
                <Box display="flex" flexDirection="column" gap={2} marginBottom={4} key={index}>
                    <Typography variant="h4">
                        <b>{course.title}</b>
                    </Typography>

                    <Box marginLeft={2}>
                        <Typography variant="h6" component="p">
                            {course.description}
                        </Typography>
                    </Box>

                    <Box marginLeft={2}>
                        <Typography variant="h5" component="p">
                            <b>Requirements:</b>
                        </Typography>
                    </Box>

                    <Box marginLeft={2}>
                        <List>
                            {course.requirements.map((requirement, index) => (
                                <ListItem key={index}>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" fontSize="large" />
                                    </ListItemIcon>
                                    <Typography variant="h6">{requirement}</Typography>
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                </Box>
            ))}

        </Box>
    );
}

export default CoursesRequiredForLicense;